import i18n from '@/i18n'

export class PieChartData {
  public constructor (
    readonly name: string,
    readonly value: number,
  ) {}

  static createListFromResponse (data: any): Array<PieChartData> {
    return Object.keys(data).map((key) => {
      return new PieChartData(
        i18n.t(`dashboard.${String(key)}`).toString(),
        data[key]
      )
    })
  }
}
